import gql from 'graphql-tag'

export const queryContractTemplateByPk = id => {
	return {
		query: gql`
			query ($id: bigint!) {
				pdf_templates_by_pk(id: $id) {
					name
					organization_id
					country
					comercial_base
					contract_type
					comercial_category_id
				}
			}
		`,
		update(data) {
			return {
				name: data.pdf_templates_by_pk.name,
				organizationId: data.pdf_templates_by_pk.organization_id,
				country: data.pdf_templates_by_pk.country,
				comercialBase: data.pdf_templates_by_pk.comercial_base,
				contractType: data.pdf_templates_by_pk.contract_type,
				comercialCategoryId: data.pdf_templates_by_pk.comercial_category_id
			}
		},
		variables: {
			id: parseInt(id)
		}
	}
}
